<amc-search-information
  [ActivityDetails]="this.storageService.activityList[this.storageService.currentScenarioId]"
  [searchLayout]="searchLayout"
  [searchRecordList]="searchRecordList"
  (agentSelectedCallerInformation)="onAgentSelectedCallerInformation($event)"
>
</amc-search-information>
